
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";

interface EmptyStateProps {
  searchQuery: string;
  activeTab: "all" | "admin" | "vendor" | "user" | "invitations";
}

export const EmptyState: React.FC<EmptyStateProps> = ({ searchQuery, activeTab }) => {
  return (
    <TableRow>
      <TableCell colSpan={4} className="text-center py-8 text-gray-500">
        {searchQuery ? 
          "No users match your search criteria." : 
          activeTab === "all" 
            ? "No users found. Make sure profiles exist in the database."
            : `No ${activeTab} users found.`
        }
      </TableCell>
    </TableRow>
  );
};
